if (document.location.href.indexOf('localhost') > 0 || document.location.href.indexOf('pay.staging') > 0) {
  if(document.location.href.indexOf('pay.localhost') > 0){
    // window.apiUrl = "https://api.velora.com.br";
    window.apiUrl = "http://api.localhost:8000";
  }else{
    window.apiUrl = "https://api.staging.velora.com.br";
  }
} else {
  window.apiUrl = "https://api.velora.com.br";
}